<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <app-modal-back
        icon="close"
        ariaLabel="close"
      ></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="assessmentData">
    <div class="mable-section ion-margin-top">
      <mable-heading
        heading="h2"
        headingStyle="h1"
      >
        Evaluation for {{ assessmentData.agreement.otherUser.firstName }}?
      </mable-heading>
      <div class="sub-section">
        <mable-heading
          heading="h3"
          headingStyle="h5"
          icon="calendar"
        >
          {{ assessmentData.periodStartDate | date: 'd MMMM' }}
        </mable-heading>
        <p class="ion-margin-horizontal">
          Your anonymous input helps your support worker using Mable improve their services and reliability.
        </p>
        <form
          [formGroup]="form"
          novalidate
        >
          <mable-input
            label="Did {{ assessmentData.agreement.otherUser.firstName }} show up for this session?"
            [noBorder]="true"
            [hasError]="form.controls.isShowedUp.showError()"
          >
            <mb-radio-group
              formControlName="isShowedUp"
              valueField="value"
              [options]="radioGroupOptions"
              radioStyle="default-grid"
              class="small-radio-buttons"
            >
            </mb-radio-group>
            <p class="warn">Select an option.</p>
          </mable-input>
          <mable-input
            label="Did {{ assessmentData.agreement.otherUser.firstName }} turn up on time or provided enough notice?"
            [noBorder]="true"
            [hasError]="form.controls.isOnTime.showError()"
          >
            <mb-radio-group
              formControlName="isOnTime"
              valueField="value"
              [options]="radioGroupOptions"
              radioStyle="default-grid"
              class="small-radio-buttons"
            >
            </mb-radio-group>
            <p class="warn">Select an option.</p>
          </mable-input>
          <mable-input
            label="Were agreed tasks completed at an acceptable standard?"
            [noBorder]="true"
            [hasError]="form.controls.isTaskCompleted.showError()"
          >
            <mb-radio-group
              formControlName="isTaskCompleted"
              valueField="value"
              [options]="radioGroupOptions"
              radioStyle="default-grid"
              class="small-radio-buttons"
            >
            </mb-radio-group>
            <p class="warn">Select an option.</p>
          </mable-input>
          <mable-input label="Any other feedback? (optional)">
            <ion-textarea
              formControlName="otherFeedback"
              autocapitalize="sentences"
              autosize
              rows="4"
            >
            </ion-textarea>
          </mable-input>
        </form>
      </div>
    </div>
  </ng-container>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <mable-button
          category="outline"
          expand="block"
          (onClick)="openCancelModal()"
        >
          Back
        </mable-button>
      </ion-col>
      <ion-col>
        <mable-button
          expand="block"
          (onClick)="submitEvaluation()"
        >
          Submit
        </mable-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
